/**
 * Botón de acceso a Genio Documental (regla de Diego 2026-09-18): TODO acceso
 * a Genio lleva uno de sus logos, nunca un ojo ni un ícono genérico. Fuente
 * única del acceso pequeño: logo de Genio sobre el naranja de "Ver Soporte".
 * Con children pinta logo + texto; sin children, solo el logo.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-09-18
 */
import React from "react";
import { Button } from "codekit";
import "./riodo.css";

const Botgenio = ({ onClick, title = "Ver en Genio Documental", size = "s", children = null, style = undefined }) => (
  <span className="rio-botgenio" title={title} style={style}>
    <Button type="button" size={size} variant="warning" icon="genio" onlyIcon={!children} onClick={onClick} aria-label={title}>
      {children}
    </Button>
  </span>
);

export default Botgenio;
